import * as actions from './actions';
import * as userActions from '../user/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    newsScroll: 0,
    lawsScroll: 0,
    digestsScroll: 0,
};

export const savedScrollsReducer = (state = initialState, action) => {
    switch (action.type) {
        // NEWS
        case actions.SAVE_NEWS_FEED_SCROLL:
            return {
                ...state,
                newsScroll: action.scroll,
            };

        // LAWS
        case actions.SAVE_LAWS_FEED_SCROLL:
            return {
                ...state,
                lawsScroll: action.scroll,
            };

         // DIGESTS
         case actions.SAVE_DIGESTS_FEED_SCROLL:
            return {
                ...state,
                digestsScroll: action.scroll,
            };

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/savedScrolls/reducer.js